// Libs
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

// Config
import { PATHS } from '~fpu/config/constants';

// Types
import { UpdateWorkshopPayload, Workshop } from '../types';

function useUpdateWorkshop(workshopId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: UpdateWorkshopPayload) =>
      axios.put<Workshop>(PATHS.API.WORKSHOPS.DETAIL(workshopId), payload),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['workshopDetails', workshopId]
      });
      queryClient.invalidateQueries({ queryKey: ['orgWorkshops'] });
    },
    throwOnError: true
  });
}

export { useUpdateWorkshop };
